/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { FC } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { actionCreator } from "store/store"
import { Button } from "@duxton-web/ui"
import { AddCircleFilled } from "@duxton-web/icons"
import { useTranslation } from "common/utils/i18n"
import { AppState } from "store/store.type"
import { TroyWebTracker } from "utils/tracking"
import { EventAction, EventCategory } from "constants/tracking"
import { emptyContentContainer } from "./styles"

interface EmptyCategoriesProps {
  hideCreate?: boolean
}

export const EmptyCategories: FC<EmptyCategoriesProps> = ({
  hideCreate = true,
}: EmptyCategoriesProps) => {
  const dispatch = useDispatch()

  const {
    merchantID,
    overview: { section },
    isEditAllowed,
    menuGroupDetail: { menuGroupID },
    merchantGroupID,
  } = useSelector((state: AppState) => state.menu)

  const location = useLocation()
  const eventCategory = location.pathname.endsWith("/items")
    ? EventCategory.menuItemsTab
    : EventCategory.menuOverviewTab

  const onClick = () => {
    TroyWebTracker.sendEvent({
      category: eventCategory,
      action: EventAction.clickAddCategory,
      labels: merchantID
        ? { STORE_ID: merchantID }
        : { MERCHANT_GROUP_ID: merchantGroupID, MENU_GROUP_ID: menuGroupID },
    })

    dispatch(
      actionCreator.menu.toggleDrawer({
        category: {
          sectionID: section?.sectionID,
        },
        showCategory: true,
      }),
    )
  }

  const textCreate = useTranslation("menu.overview.buttons.addNewCategory")

  return (
    <div
      // className={className}
      css={css`
        top: 50%;
        left: 50%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: column;
      `}
    >
      <div css={emptyContentContainer} data-testid="empty-categories">
        <img src={require("./emptyItems.svg")} height={160} width={160} />
        {!hideCreate && (
          <Button
            icon={<AddCircleFilled />}
            onClick={onClick}
            disabled={!isEditAllowed}
          >
            {textCreate}
          </Button>
        )}
      </div>
    </div>
  )
}
